import { INVITE_DRIVER_FAILURE } from "../../driver/constants";
import {
  INVOICES_LIST_SUCCESS,
  PAYMENT_LIST_FAILURE,
  PAYMENT_LIST_REQUEST,
  PAYMENT_LIST_SUCCESS,
  RESET_INVOICE_LIST,
} from "../constants";
import { INVOICES_LIST_REQUEST } from "../constants";

const INITIAL_STATE = {
  isLoading: false,
  paymentList: [],
  invoiceList: [],
};

const paymentInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_INVOICE_LIST:
      return {
        ...state,
        invoiceList: [],
        isLoading: true,
      };
    case INVOICES_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case INVITE_DRIVER_FAILURE:
      return {
        ...state,
        invoiceList: [],
        isLoading: false,
      };
    case INVOICES_LIST_SUCCESS:
      return {
        ...state,
        invoiceList: action.payload,
        isLoading: false,
      };
    case PAYMENT_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        paymentList: action.payload,
        isLoading: false,
      };
    case PAYMENT_LIST_FAILURE:
      return {
        ...state,
        paymentList: [],
        isLoading: false,
      };
    default:
      return state;
  }
};

export default paymentInvoice;
